interface PlayerInfoRegularLeagueProps {
  poolSeedNumber: number;
  firstName: string;
  lastName: string;
  showIconFirst?: boolean;
  iconLabelFirst?: string;
  showIconSecond?: boolean;
  iconLabelSecond?: string;
  subbedPlayer: string | null;
  isUserAlsoPlayer: boolean;
}

export const PlayerInfoRegularLeague = ({
  poolSeedNumber,
  firstName,
  lastName,
  showIconFirst,
  showIconSecond,
  iconLabelFirst,
  iconLabelSecond,
  subbedPlayer,
  isUserAlsoPlayer,
}: PlayerInfoRegularLeagueProps) => (
  <div className='flex items-center'>
    <span
      className={`line-clamp-3 text-base font-medium ${isUserAlsoPlayer ? 'text-leagues-500/90' : 'text-gray-900'}`}
    >
      {`${poolSeedNumber}. ${subbedPlayer === null ? `${firstName} ${lastName}` : 'SUB for ' + subbedPlayer}`}
    </span>
    {showIconFirst ? (
      <div className='ml-2 flex size-[25px] items-center justify-center rounded-full bg-gray-400 text-sm text-white'>
        {iconLabelFirst}
      </div>
    ) : null}
    {showIconSecond ? (
      <div className='ml-2 flex size-[25px] items-center justify-center rounded-full bg-gray-400 text-sm text-white'>
        {iconLabelSecond}
      </div>
    ) : null}
  </div>
);
